import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import fetchBooks from "../redux/books/thunk/fetchBooks";
import BookCard from "./BookCard";

export default function BookContainer() {
  const dispatch = useDispatch();
  const { books } = useSelector((state) => state.books);
  const { featuredFilter, keyword } = useSelector((state) => state.filters);

  useEffect(() => {
    dispatch(fetchBooks);
  }, [dispatch]);


  return (
    <div className="lws-bookContainer">
      {books?.length > 0
        ? books
            ?.filter((book) =>
              book.featured === featuredFilter ? book : book.featured && book
            )
            ?.filter((book) => book.name.toLowerCase().includes(keyword))
            ?.map((book) => <BookCard key={book.id} book={book} />)
        : "Loading..."}
    </div>
  );
}
